import React from 'react';
import { Card } from 'react-bootstrap';
import '../../styles/Panel.css';

const WorkOrdersTableCard = (props) => {
    const { setShowWorkOrdersTable } = props;
 
    return (
    <Card className="user-panel-card" onClick={() => setShowWorkOrdersTable(true)}>
      <Card.Img className="user-panel-image" variant="top" src="/icons/test_4.svg"/>
      <Card.Body>
        <Card.Title className="user-panel-title">Work Orders Table</Card.Title>
        <Card.Text className="user-panel-description">
          Work Order Information
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default WorkOrdersTableCard;
